// src/components/CheckboxList.js

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function CheckboxList({ items = [], selectedIds, setSelectedIds, label }) {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false); // По умолчанию список развернут

  const handleCheckboxChange = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((itemId) => itemId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  return (
    <div className="mt-4">
      <h5 onClick={() => setIsExpanded(!isExpanded)} style={{ cursor: 'pointer' }}>
        {t(label)} {isExpanded ? '▲' : '▼'}
      </h5>
      {isExpanded && (
        <div className="form-group" style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {items.map((item) => (
            <div key={item.id} className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id={`item-${item.id}`}
                checked={selectedIds.includes(item.id)}
                onChange={() => handleCheckboxChange(item.id)}
              />
              <label className="form-check-label" htmlFor={`item-${item.id}`}>
                {item.name}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CheckboxList;
